<div class="app-radio-group-wrapper" [ngClass]="customClass">
  <!-- Group Label (if provided) -->
  <app-label
    *ngIf="resolvedLabel"
    [text]="resolvedLabel"
    [mandatory]="isRequired"
    [optional]="optional"
    [tooltip]="tooltip"
    [icon]="labelIcon"
    [size]="labelSize"
  ></app-label>

  <!-- Radios Container -->
  <div
    class="app-radio-group"
    [ngClass]="{
      'app-radio-group--row': row,
      'app-radio-group--column': !row
    }"
    [style.gap]="gap"
  >
    <!-- Dynamic Options (if options array provided) -->
    <ng-container *ngIf="options && options.length > 0">
      <app-radio
        *ngFor="let opt of options"
        [value]="opt.value"
        [label]="opt.label"
        [description]="opt.description"
        [checked]="value === opt.value"
        [disabled]="disabled || opt.disabled"
        [name]="name"
        (change)="onSelect($event)"
      ></app-radio>
    </ng-container>

    <!-- Projected Content (<app-radio> elements) -->
    <ng-content></ng-content>
  </div>

  <!-- Error Message -->
  <div *ngIf="hasError" class="app-radio-group__error">
    {{ errorMsg }}
  </div>

  <!-- Helper Text -->
  <div *ngIf="helperText && !hasError" class="app-radio-group__helper">
    {{ helperText }}
  </div>
</div>
